var render = function render(){var _vm=this,_c=_vm._self._c;return _c('deploy-log-list',{attrs:{"page":_vm.page,"items-per-page":_vm.itemsPerPage,"search":_vm.search,"workload-type":_vm.workloadType,"deployment-type":_vm.deploymentType}})
}
var staticRenderFns = []

export { render, staticRenderFns }